export default __webpack_public_path__ + "static/media/3.652194e7.jpg";